import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1c896566"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mix-selector-content cm-ui-mr15" }
const _hoisted_2 = { class: "btn-group gap-x-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeSelector = _resolveComponent("TimeSelector")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectorsValue, (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "sub-row mix-selector-container cm-ui-mt10",
        key: item
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_TimeSelector, {
            idx: idx,
            "main-switch": _ctx.mainSwitch,
            "mix-type": _ctx.mixType,
            item: _ctx.selectorsValue[idx],
            "s-key": _ctx.sKey
          }, null, 8, ["idx", "main-switch", "mix-type", "item", "s-key"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          (idx === 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                style: {"padding":"8px","border-radius":"99999px !important"},
                circle: "",
                plain: "",
                size: "mini",
                onClick: _ctx.addSelector,
                icon: "el-icon-plus"
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"padding":"8px","border-radius":"99999px !important"},
            circle: "",
            plain: "",
            size: "mini",
            onClick: ($event: any) => (_ctx.subSelector(idx)),
            icon: "el-icon-minus"
          }, null, 8, ["onClick"])
        ])
      ]))
    }), 128))
  ]))
}